module.exports = __webpack_public_path__ + "static/media/uploadDocumentsPage.f430a535.jpg";